import { Flex, Image, Tooltip } from '@chakra-ui/react';
import Platforms, { PlatformEnums } from '../../../../../utils/platforms';

const PlatformCellRenderer = ({ value }) => {
    const platform = () => {
        const platform = Platforms[value];
        return platform;
    };

    const isEightByEight = platform()?.name === '8x8';

    // (3022) The GCC High flag logo is square, so it gets the same circular
    // crop as 8x8 to sit with the round platform logos.
    const isGCCHigh =
        value === PlatformEnums.GCC || value === 'ms_resource_account_gcch';

    const roundedLogo = isEightByEight || isGCCHigh ? 'rounded-full' : '';

    return (
        <Flex align="center" justify="center" height="100%">
            <Tooltip label={platform()?.name} placement="top">
                {/* <> */}
                <Image
                    src={platform()?.icon}
                    boxSize="7"
                    className={roundedLogo}
                />
                {/* {platformName && <span>{platform()?.name}</span>} */}
                {/* </> */}
            </Tooltip>
        </Flex>
    );
};

export default PlatformCellRenderer;
